import api from '@/api';
import cookie from '@/api/cookie';
const config = require('../../../config');
import router from '@/router';

const state = {
  token: cookie.getToken(),
  userInfo: {},
  menus: [],
  alreayGeneraterMenus: false,
  loginStatus: 0,
  areaList: [], //权限-地域列表
  areaListAll: [], //权限-地域列表
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERINFO: (state, data) => {
    state.userInfo = data;
  },

  SET_MENUS: (state, menus) => {
    state.menus = menus;
  },
  UPDATE_MENUS_STATUS: (state, status) => {
    state.alreayGeneraterMenus = status;
  },
  SET_LOGIN_STATUS: (state, status) => {
    state.loginStatus = status;
  },
  UPDATE_AREA_LIST: (state, { list, all }) => {
    state.areaList = list;
    state.areaListAll = all;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      api.userAdmin
        .login(userInfo)
        .then((response) => {
          const { data } = response;
          commit('SET_TOKEN', data.token);
          cookie.setToken(data.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  async getUserInfo({ commit, state }) {
    let res = await api[config.WEB == 1 ? 'userAdmin' : 'user'].info({
      token: state.token,
    });
    return new Promise((resolve, reject) => {
      try {
        commit('SET_USERINFO', res.data[config.WEB == 1 ? 'admin_info' : 'user_info']);
        resolve(res.data[config.WEB == 1 ? 'admin_info' : 'user_info']);
      } catch (e) {
        reject(new Error('验证失败请重新登录'));
      }
    });
  },

  // user logout
  logout() {
    return new Promise((resolve) => {
      cookie.removeToken();
      this.dispatch('router/updateMenusStatus', false);
      if (process.env.NODE_ENV == 'development' || config.WEB == 1) {
        router.replace('/login');
      } else {
        window.location.href = `${config.API_BASE}/login`;
      }

      resolve();
    });
  },

  // 获取菜单
  getMenus({ commit }) {
    return new Promise((resolve, reject) => {
      api[config.WEB == 1 ? 'userAdmin' : 'user']
        .getMenus()
        .then((res) => {
          if (!res.data) {
            return reject(new Error('获取菜单失败'));
          }
          commit('SET_MENUS', res.data);
          return resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async updateLoginStatus({ commit }) {
    try {
      let res = await api.user.loginStatus();
      let loginStatus = res.data.login_status;
      commit('SET_LOGIN_STATUS', loginStatus);
      return loginStatus;
    } catch (e) {
      console.error(e);
    }
  },

  //获取权限-区域列表
  async getAreaList({ commit, state }, update) {
    try {
      if (state.areaList.length && !update) {
        return Promise.resolve(state.areaList);
      }
      let res = await api.works.getArea();
      let areaList = [];
      if (state.userInfo.level == 1) {
        areaList = res.data[0].child;
      }
      if (state.userInfo.level == 2) {
        areaList = res.data[0].child[0].child;
      }
      if (state.userInfo.level == 3) {
        areaList = res.data[0].child[0].child;
      }
      commit('UPDATE_AREA_LIST', { list: areaList, all: res.data });
      return Promise.resolve(areaList);
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
